function confirmedMessageMatchesOptimistic(message, optimisticMessage) {
  return (
    message.message_id === optimisticMessage.message_id ||
    message.message_id === `live_chat:${optimisticMessage.client_message_id}`
  );
}

export function mergeMessages(currentMessages, incomingMessages) {
  const merged = [];

  [...currentMessages, ...(incomingMessages || [])].forEach((message) => {
    if (!message) return;
    const existingIndex = merged.findIndex(
      (candidate) =>
        (message.id != null && candidate.id === message.id) ||
        (message.message_id && candidate.message_id === message.message_id) ||
        (!message.pending &&
          candidate.client_message_id &&
          confirmedMessageMatchesOptimistic(message, candidate))
    );

    if (existingIndex >= 0) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        ...message,
        pending: false,
        failed: false,
        waitingForVerification: false,
      };
    } else merged.push(message);
  });

  return merged.sort((left, right) => {
    const timeDifference = Date.parse(left.created_at || 0) - Date.parse(right.created_at || 0);
    if (timeDifference) return timeDifference;
    return (Number(left.id) || Number.MAX_SAFE_INTEGER) - (Number(right.id) || Number.MAX_SAFE_INTEGER);
  });
}

export function createPendingMessage(clientMessageId, message) {
  return {
    id: null,
    message_id: `pending:${clientMessageId}`,
    client_message_id: clientMessageId,
    actor: "customer",
    message,
    message_type: "session_inbound",
    attachment: null,
    created_at: new Date().toISOString(),
    pending: true,
    failed: false,
    waitingForVerification: false,
  };
}

export function getPendingMessages(messages) {
  return messages
    .filter((message) => message.pending || message.failed)
    .map(({
      client_message_id,
      message,
      created_at,
      failed,
      waitingForVerification,
      error,
      retryAt,
    }) => ({
      client_message_id,
      message,
      created_at,
      failed: Boolean(failed),
      waitingForVerification: Boolean(waitingForVerification),
      error: error || null,
      retryAt: retryAt || null,
    }));
}

